<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-11 15:42:21
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-03-04 16:25:23
--> 
<template>
  <div>
    <mrc_ess_iconGroup :is_disabled='$store.state.iconstatus' :showReturn='false'
      :showEdit="hasBtn('edit-staff-property-group')" :show_del="hasBtn('delete-staff-property-group')"
      @handleEdit='handleEdit' @handleDel='handleDel'>

    </mrc_ess_iconGroup>

    <v-tabs v-model="tab" grow @change="tabchange" background-color="#eeeef0" color='primary' dark>
      <v-tab v-for="(item, index) in items" class="text-capitalize" :key="index">
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <editGeneral :readonly='readonly' @changereadonly='handleEdit'></editGeneral>
      </v-tab-item>

      <v-tab-item style="background-color:#fff">
        <staffGroup :readonly='readonly' @changereadonly='handleEdit' ref="staffGroup"></staffGroup>
      </v-tab-item>

    </v-tabs-items>
  </div>
</template>

<script>
import editGeneral from './editGeneral'
import staffGroup from './staffGroup'
import {
  getStaffPropertyGroupDetail,
  getPropertyGroupDetail,
  deleteStaffPropertyGroup,
  updateStaffPropertyGroup,
  addStaffPropertyGroup,
  getAddList
} from '@/service/api/staffPropertyGroup.js'
export default {
  components: {
    editGeneral,
    staffGroup
  },
  props: {},
  data() {
    return {
      tab: 0,
      e1: 1,
      readonly: true,//默认只读
    };
  },
  beforeDestroy() {
    this.$store.commit('setTab', '')
  },
  created() {

  },
  async mounted() {
    this.readonly = this.$store.state.iconstatus
    this.tab = this.$store.state.tab
  },
  methods: {
    tabchange() {
      this.$store.commit('setTab', this.tab)
      if (this.tab == 1) {
        this.$refs.staffGroup ? this.$refs.staffGroup.getdetail() : ''
      }
    },
    handleEdit() {
      this.readonly = !this.readonly
      this.$store.commit('set_iconstatus', this.readonly)
    },
    handleDel() {
      this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') }).then(res => {
        deleteStaffPropertyGroup({ uuid: this.$store.state.uuid }).then(res => {
          if (res.code == 200) {
            this.$Message({ text: this.$t('message_The_deletion_was_successful') })
            this.$router.push({
              name: 'staffPropertyGroup',
              params: {
                type: 'del'
              }
            })
          }
        })
      })
    },
  },
  computed: {
    items() {
      return [
        { tab: this.$t('label_The_general_information') },
        { tab: this.$t('label_propety') },
      ]
    }
  },
  watch: {
    readonly: {
      handler(v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_StaffPropertyGroup'
          this.$store.commit('set_page_title', 'label_edit_StaffPropertyGroup')
        }
        else {
          this.$route.meta.title = 'label_viewStaffPropertyGroup'
          this.$store.commit('set_page_title', 'label_viewStaffPropertyGroup')
        }
      }, immediate: true
    }
  },
};
</script>

<style scoped></style>
